import { useDirectMarkerUpdates } from 'components/minute/builders/v2/useDirectMarkerUpdates';
import { LocationSearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/LocationSearchInput';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { motion } from 'framer-motion';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { getCoordinateBounds } from 'libs/utils/world/worldUtils';
import { useContext } from 'react';
import { ICoordinates, IDirectionWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const DirectionToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const createMarkers = useCreateWorldMarkerV2();
    const directMarkerUpdates = useDirectMarkerUpdates();

    const markerInCreation = ctxEdit.markerCreation?.marker as IDirectionWorldMarker | null;

    const noPointExists = !Boolean(markerInCreation);

    function navigateToMarker(coordinates: ICoordinates) {
        ctxEdit.mapRef.current?.flyTo({
            center: coordinates,
            zoom: 12,
            animate: true,
            speed: 2
        });
    }

    function navigateToResult(coordinates: ICoordinates[]) {
        const bounds = getCoordinateBounds(coordinates);

        ctxEdit.mapRef.current?.fitBounds(bounds, {
            padding: 200,
            speed: 2,
            animate: true
        });
    }

    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_DirectionToolSidebar className={props.className}>
                <SidebarSubsection
                    title={Localization.ADDRESS_SEARCH}
                    icon={{ iconName: 'location-dot' }}
                >
                    <SidebarContent>
                        <LocationSearchInput
                            palceholder={
                                noPointExists
                                    ? Localization.STARTING_POINT
                                    : Localization.DESTINATION
                            }
                            onLocationSelected={({ lat, lng }) => {
                                const coordinates = { lat, lng };
                                if (noPointExists) {
                                    createMarkers.createDirection(coordinates);
                                    navigateToMarker(coordinates);
                                    directMarkerUpdates.addTempCircle(
                                        coordinates,
                                        ctxEdit.markerDefault.color
                                    );
                                } else {
                                    createMarkers.finishDirection(coordinates);
                                    const allCoordinates = [
                                        markerInCreation.elementData.coordinates[0],
                                        coordinates
                                    ];
                                    navigateToResult(allCoordinates);
                                    directMarkerUpdates.removeTempCirlce();
                                }
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
            </S_DirectionToolSidebar>
        </motion.div>
    );
};

const S_DirectionToolSidebar = styled.div`
    width: 100%;
`;
